import { GET_DELIVERYMAN_UNIQUE_SHOPS_DETAIL_REPORT } from "../../../Types";

const DlmUniqueShopsDetailReportReducer = (state = [], action) => {
  switch (action.type) {
    case GET_DELIVERYMAN_UNIQUE_SHOPS_DETAIL_REPORT:
      return action.payload;
    default:
      return state;
  }
};
export default DlmUniqueShopsDetailReportReducer;
